var map = {
	"./app.svg": 1960,
	"./appA.svg": 705,
	"./application.svg": 1961,
	"./applicationA.svg": 706,
	"./approval.svg": 1962,
	"./approvalA.svg": 707,
	"./home.svg": 1963,
	"./homeA.svg": 708
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1959;


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img ^\.\/.*\.svg$
// module id = 1959
// module chunks = 0